import React, { createContext, useContext } from 'react';

const Context = createContext();
const useActions = () => useContext(Context);

const ActionsProvider = ({ value, children }) => {
  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export { ActionsProvider, useActions };
